import { render, staticRenderFns } from "./Bubble.vue?vue&type=template&id=219d41a6&scoped=true"
import script from "./Bubble.ts?vue&type=script&lang=js&external"
export * from "./Bubble.ts?vue&type=script&lang=js&external"
import style0 from "./Bubble.vue?vue&type=style&index=0&id=219d41a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219d41a6",
  null
  
)

export default component.exports